// @ts-nocheck
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import SportsHubMessagesManagement from '@/components/admin-dashboard/SportsHubMessagesManagement';

const SportsHubMessagesManagementPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-3xl font-bold text-gray-900">
              Sports Hub Messages Management
            </CardTitle>
          </CardHeader>
          <CardContent>
            <SportsHubMessagesManagement />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SportsHubMessagesManagementPage;